/*!

=========================================================
* Argon Dashboard PRO React - v1.2.1
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-pro-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
import ReactDOM from "react-dom";
// react library for routing
import { HashRouter, Route, Switch, Redirect } from "react-router-dom";

// plugins styles from node_modules
import "react-notification-alert/dist/animate.css";
import "react-perfect-scrollbar/dist/css/styles.css";
import "@fortawesome/fontawesome-free/css/all.min.css"; 
// plugins styles downloaded
import "assets/vendor/nucleo/css/nucleo.css";
// core styles
import "assets/scss/argon-dashboard-pro-react.scss?v1.2.0";
import "assets/estilos/logo-navbar-theme.css";

import AdminLayout from "layouts/Admin.js";
import AuthLayout from "layouts/Auth.js";
import { Provider } from "react-redux";
import { store } from "store/store";

ReactDOM.render(
  <HashRouter>
    <Provider store={store}>
    <Switch>
      <Route path="/admin" render={(props) => {
        
        return <AdminLayout {...props} />
          // let validate = GuardRoutes();
          // if (validate == true) {
          // } else {
          //   return <AuthLayout {...props} />
          // }
    }} 
      />
      <Route path="/auth" render={(props) => <AuthLayout {...props} />} />
      <Route path="/" render={(props) => <AuthLayout {...props} />} />
      <Redirect from="*" to="/auth/login" />
    </Switch>
    </Provider>
  </HashRouter>,
  document.getElementById("root")
);
